import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  createApplicantFailed,
  createApplicantSuccessful,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED } from '../../../configs/serverStatusCodes';
import {
  BACKEND_URL_V2,
} from '../../../configs';

export default function* createApplicant(action) {
  try {
    const url = `${BACKEND_URL_V2}/dict/applicants`;
    const pool = action.payload;
    const response = yield makeRequest(url, pool, action, 'POST', true);
    if (response.status === CREATED) {
      const data = yield getBodyJson(response);
      yield put(createApplicantSuccessful());
      yield call(resolveActionPromise(action, data.data));
    } else {
      const data = yield getBodyJson(response);
      yield put(createApplicantFailed());
      yield call(rejectActionPromise(action, { ...data, code: response.status }));
    }
  } catch (e) {
    yield put(createApplicantFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
